// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Layout as CUILayout, Snackbar } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SnackBarConfirmation = function SnackBarConfirmation(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    open = _ref.open;
  return /*#__PURE__*/_jsx(CUILayout, {
    children: /*#__PURE__*/_jsx(Snackbar, {
      className: "p-16",
      open: open,
      position: "top-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [icon, /*#__PURE__*/_jsx("span", {
          className: "ml-12 font-body3",
          children: label
        })]
      })
    })
  });
};
export default SnackBarConfirmation;